<div style="min-height: 100vh; display: flex; flex-direction: column;">
  <!-- Header -->
  <np-header>
    <!-- Search -->
    <np-search [searchType]="SearchType.Global"></np-search>
    <!-- Global (top menu) Navigation -->
    <np-menu [location]="NavigationLocation.Global"></np-menu>
  </np-header>
  
  <!-- Site-Specific Navigation -->
  <np-menu [location]="NavigationLocation.SiteSpecific"></np-menu>
  
  <!-- Main Content -->
  <div style="flex-grow: 1;">
    <router-outlet></router-outlet>
  </div>
  
  <!-- Footer -->
  <np-footer 
    [contentContactName]="'Wells Digital Platform Execution '"
    [contentContactUrl]="'mailto:Wells_Execution_WV_Support@chevron.com'" 
    [technicalContactName]="'Santiago Carle'"
    [technicalContactUrl]="'mailto:Santiago.Carle@chevron.com'"
    [confidentiality]="'Company Confidential | Version ' + appVersion">
  </np-footer>
</div>